import { render, staticRenderFns } from "./Form2_Persona.vue?vue&type=template&id=d91ea810"
import script from "./Form2_Persona.vue?vue&type=script&lang=js"
export * from "./Form2_Persona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d91ea810')) {
      api.createRecord('d91ea810', component.options)
    } else {
      api.reload('d91ea810', component.options)
    }
    module.hot.accept("./Form2_Persona.vue?vue&type=template&id=d91ea810", function () {
      api.rerender('d91ea810', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/FENORESTE/Form2_Persona.vue"
export default component.exports